/**
 * @generated SignedSource<<76ae6e82b71a91137d576a86c401f900>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTransactionPrimaryMutation$variables = {
  aaid: string;
  token: string;
};
export type UpdateTransactionPrimaryMutation$data = {
  readonly unified: {
    readonly linking: {
      readonly updateLinkingWithPrimaryAccountAaid: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly message: string | null;
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type UpdateTransactionPrimaryMutation = {
  response: UpdateTransactionPrimaryMutation$data;
  variables: UpdateTransactionPrimaryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedLinkingMutation",
        "kind": "LinkedField",
        "name": "linking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "aaid",
                "variableName": "aaid"
              },
              {
                "kind": "Variable",
                "name": "token",
                "variableName": "token"
              }
            ],
            "concreteType": "UnifiedLinkingStatusPayload",
            "kind": "LinkedField",
            "name": "updateLinkingWithPrimaryAccountAaid",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTransactionPrimaryMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateTransactionPrimaryMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f613997a50391da0d1ec234101adc710",
    "id": null,
    "metadata": {},
    "name": "UpdateTransactionPrimaryMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTransactionPrimaryMutation(\n  $token: String!\n  $aaid: String!\n) {\n  unified {\n    linking {\n      updateLinkingWithPrimaryAccountAaid(aaid: $aaid, token: $token) {\n        message\n        success\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d74b6439534724af3f33b7203b307d9";

export default node;
